import { UnknownRecord } from "./elastic-query-builder";

export const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

export const isObject = (value: unknown): boolean => {
  return typeof value === 'object' && value !== null;
};

export const isUnknownRecord = (value: unknown): value is UnknownRecord => {
  return isObject(value) && value !== null;
};

export function isValidDate(date: Date): boolean {
  return !Number.isNaN(date.getTime())
}

export function isEmptyValue(value: string | number | null | undefined): boolean {
  return value === undefined || value === null || value === ''
}

export function isErrorLikeDonationStatus(status: string): boolean {
  const normalized = status.trim().toLowerCase()
  return normalized === 'erroring' || normalized === 'error' || normalized === 'declined'
}
